import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { StructureList } from '../../models/structure-list';
import { SelectionArguments } from '../../models/selection-arguments';
import { RBCheck } from '@ldw/roesberg';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { StructureInfo } from '../../models/structure-info';
import { LdwRouterService } from '../../../route/ldw-router.service';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'ldw-structure-list-view',
    templateUrl: './structure-list-view.component.html',
    styleUrls: ['./structure-list-view.component.css'],
    standalone: false
})
export class StructureListViewComponent {
  private routerService = inject(LdwRouterService);

  private _data: StructureList = new StructureList();
  private _selectedId = '';
  private initialized = false;
  protected scrolled$ = new Subject<number>()
  @Input() disablePreview = false;
  @Input() showTreePath = false;
  @Input() showNoData = false;
  @Input() search = '';
  @Input() set data(value: StructureList) {
    if (this.selectedId && !this._data.data.length) {
      this.scrollIntoView((value && value.data) || [], this.selectedId);
    }
    this._data = value;
    setTimeout(() => {
      this.initialized = true;
      const offset = this.routerService.getQueryParam('offset');
      if (offset && +offset > 0) {
        this.viewPort?.scrollToIndex(+offset);
      }
    }, 0);
  }
  get data(): StructureList {
    return this._data;
  }

  @Input() set selectedId(value: string) {
    if (this.data.data.length && !this._selectedId) {
      this.scrollIntoView(this.data.data, value);
    }
    this._selectedId = value;
  }
  get selectedId() {
    return this._selectedId;
  }
  @Output() itemSelected: EventEmitter<SelectionArguments> = new EventEmitter();

  @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport | undefined;

  constructor() {
    this.scrolled$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      takeUntilDestroyed()
    ).subscribe(index => this.setOffset(index))
  }

  scrollIntoView(data: StructureInfo[], selectedId: string) {
    const index = data.findIndex((element) => element.id === selectedId);
    if (index > -1) {
      setTimeout(() => {
        this.viewPort?.scrollToIndex(index === 0 ? 0 : index - 1);
      }, 0);
    }
  }

  setOffset(scrollIndex: number) {
    if (!scrollIndex && !this.initialized) {
      return;
    }
    this.routerService.setQueryParams('offset', `${scrollIndex}`, true);
  }

  hasData(): boolean {
    return this.data.data.length > 0;
  }

  hasPathData(): boolean {
    return this.hasData() && !RBCheck.isNullOrEmpty(this.data.pathInfo);
  }

  internalSelection(args: SelectionArguments) {
    if (args != undefined) {
      console.log('item click 1', args);
      this.itemSelected.emit(args);
    }
  }

  breadcrumbSelected(args: SelectionArguments) {
    if (args != undefined) {
      this.itemSelected.emit(args);
    }
  }
}
